import React, { Component } from 'react'
import { connect } from 'react-redux';
import './DialogBlockchainDeposit.css';
import { changeInputValue } from './DialogBlockchainDepositActions';
import { deployAgreement, implicitSelectDeployAgreement } from './AgreementActions';
import DialogTitle from './DialogTitle';
import GapCard from './GapCard';
import { PublicDialogButton as ButtonAction } from './PublicDialog';
import { depositTerms, depositFundsKey, readDepositFunds } from './DepositFunds';
import { summaryFromAgreementBlockchain, getUserLinkElement, track, getTestModeFromStore } from "./ActionUtils";
import { shared } from "../Shared";
import Link from './Link';
import { 
  deposit,
  approveAllowanceForAgreement
} from './BlockchainActions';
import loadImg from '../load_blue.gif';
import moment from 'moment-timezone';

class DialogBlockchainDeposit extends Component {

  constructor(props, context) {
    super(props)
    this.state = { funds: { status: 'loading' } };
    this.balanceRequest = 0;

    // This binding is necessary to make `this` work in the callback
    this.deploy = this.deploy.bind(this);
    this.deposit = this.deposit.bind(this);
    this.implicitDeploy = this.implicitDeploy.bind(this);
    this.handleApproveAllowanceForDeposit = this.handleApproveAllowanceForDeposit.bind(this);
    this.changeInputValue = this.changeInputValue.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    if (this.props.restoreFocusTo) {
      this.pendingFocus = { name: this.props.restoreFocusTo, key: this.fundsKey(this.props) };
      // The submit button is disabled/absent until the fresh balance arrives.
      this.panel.focus({ preventScroll: true });
    }
    this.refreshFunds();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.balanceRequest++;
  }

  componentDidUpdate(prevProps) {
    if (this.fundsKey(prevProps) !== this.fundsKey(this.props) ||
      (!prevProps.dialogBlockchainDeposit.allowanceApprovalTransactionComplete && this.props.dialogBlockchainDeposit.allowanceApprovalTransactionComplete)) {
      this.refreshFunds();
    }
    this.restoreDepositFocus();
  }

  fundsKey = props => depositFundsKey(props.auth, props.agreement, props.dialogBlockchainDeposit.action);

  restoreDepositFocus = () => {
    const target = this.pendingFocus;
    if (!target) return;
    if (target.key !== this.fundsKey(this.props) || document.activeElement !== this.panel) {
      this.pendingFocus = null;
      return;
    }
    if (this.currentFunds().status === 'loading') return;
    this.pendingFocus = null;
    // Failed/insufficient reads return focus to retry/refresh, never a disabled
    // submit button. Do not move it later if the user has already moved on.
    const button = this.panel.querySelector('button[name="' + target.name + '"]:not(:disabled)') ||
      this.panel.querySelector('.depositBalanceRefresh:not(:disabled)');
    if (button) button.focus({ preventScroll: true });
  };

  refreshFunds = async () => {
    const key = this.fundsKey(this.props);
    const request = ++this.balanceRequest;
    const current = () => this.mounted && request === this.balanceRequest && key === this.fundsKey(this.props);
    this.setState({ funds: { status: 'loading', key } });
    try {
      const terms = depositTerms(this.props.agreement, this.props.dialogBlockchainDeposit.action);
      const funds = await readDepositFunds(this.props.auth, terms);
      if (current()) this.setState({ funds: { ...funds, status: 'ready', key } });
    } catch (error) {
      if (current()) this.setState({ funds: { status: 'error', key } });
    }
  };

  currentFunds = () => this.state.funds.key === this.fundsKey(this.props) ? this.state.funds : { status: 'loading' };

  canSubmit = () => {
    const funds = this.currentFunds();
    return funds.status === 'ready' && funds.hasBalance && funds.hasETH && funds.hasAllowance;
  };

  deploy(name, value) {
    if (!this.canSubmit()) return;
    this.props.dispatch(track("action", "button", JSON.stringify({type:"submit_deposit_deploy", dialog:"blockchain_deposit"})));
    let { youAreUser1=false, youAreUser2=false, agreementid="", agreedSha3="", metaevidenceHash="", agreedData="" } = this.props.agreement;
    if (agreedSha3 !== "" && agreedData !== "" && (youAreUser1 || youAreUser2)) {
      this.props.dispatch(deployAgreement(youAreUser1, youAreUser2, agreementid, agreedSha3, metaevidenceHash, agreedData));
    }
  }

  implicitDeploy(name, value) {
    if (!this.canSubmit()) return;

    let { youAreUser1=false, youAreUser2=false, agreementid="", versionid="", agreedSha3="", metaevidenceHash="", agreedData="", user1Locked="", user2Locked="" } = this.props.agreement;

    let counterPartyLocked = user2Locked;
    if (youAreUser2) {
      counterPartyLocked = user1Locked;
    }

    this.props.dispatch(track("action", "button", JSON.stringify({type:"submit_deposit_deploy", dialog:"blockchain_deposit", implicit_select: true})));
    if (youAreUser1 || youAreUser2) {
      this.props.dispatch(implicitSelectDeployAgreement(youAreUser1, youAreUser2, agreementid, versionid, agreedSha3, metaevidenceHash, agreedData, counterPartyLocked));
    }

    //console.log("implicitDeploy");
  }

  deposit(name, value) {
    if (!this.canSubmit()) return;
    this.props.dispatch(track("action", "button", JSON.stringify({type:"submit_deposit_existing", dialog:"blockchain_deposit"})));
    let blockchainDataObj = summaryFromAgreementBlockchain(this.props.agreement);
    let { deployedid="", agreedData="", contractType="" } = this.props.agreement;

    this.props.dispatch(deposit(blockchainDataObj, deployedid, agreedData, contractType));
  }

  handleApproveAllowanceForDeposit(name, value) {
    const funds = this.currentFunds();
    if (funds.status !== 'ready' || !funds.hasETH) return;
    this.props.dispatch(track("action", "button", JSON.stringify({type:"approve_allowance", dialog:"blockchain_deposit"})));

    let { youAreUser1=false, youAreUser2=false } = this.props.agreement;
    if (youAreUser1 || youAreUser2) {
      const { token, amountRaw, contractType } = depositTerms(this.props.agreement, this.props.dialogBlockchainDeposit.action);
      this.props.dispatch(approveAllowanceForAgreement(token, amountRaw, contractType));
    }
  }

  changeInputValue(name, value) {
    this.props.dispatch(changeInputValue(name, value));
  }
  
  render() {
    
    let {
      youAreUser1=false,
      youAreUser2=false,
      user1Locked="", 
      user2Locked="",
      user1Disp="",
      user2Disp=""
    } = this.props.agreement;


    let counterPartyLink = "<none>";
    let counterPartyLinkUC = "<none>";
    if (youAreUser1) {
      if (user2Locked) {
        counterPartyLink = getUserLinkElement(user2Locked, user2Disp); 
        counterPartyLinkUC = getUserLinkElement(user2Locked, shared.firstLetterUpperCase(user2Disp)); 
      } else {
        counterPartyLink = user2Disp;
        counterPartyLinkUC = shared.firstLetterUpperCase(user2Disp);
      }
    } else if (youAreUser2) {
      if (user1Locked) {
        counterPartyLink = getUserLinkElement(user1Locked, user1Disp); 
        counterPartyLinkUC = getUserLinkElement(user1Locked, shared.firstLetterUpperCase(user1Disp));
      } else {
        counterPartyLink = user1Disp;
        counterPartyLinkUC = shared.firstLetterUpperCase(user1Disp);
      }
    }

    let action = this.props.dialogBlockchainDeposit.action;
    let terms = {};
    try { terms = depositTerms(this.props.agreement, action); } catch (error) { /* The check shows an error and keeps submission disabled. */ }
    const { token: contributionType = '', amount: contributionAmount = '' } = terms;
    let dialogTitle = (action === "implicit_finalize") ? "Deposit funds without approval" : "Deposit funds";
    const funds = this.currentFunds();
    const ready = funds.status === 'ready';
    const hasAllowance = ready && funds.hasAllowance;
    const hasBalance = ready && funds.hasBalance;
    const hasETH = ready && funds.hasETH;
    let waitingForApproveAllowance = this.props.dialogBlockchainDeposit.waitingForApproveAllowance;
    let waitingApproveAllowanceHash = this.props.dialogBlockchainDeposit.waitingApproveAllowanceHash;
    let nowTimestampUnix = moment().tz('America/Los_Angeles').unix();
    let waitingTimestampUnix = this.props.dialogBlockchainDeposit.waitingTimestampUnix;

    // Don't wait for allowance approval if already detected
    if (hasAllowance || nowTimestampUnix > waitingTimestampUnix + 30) {
      waitingForApproveAllowance = false;
    }
    
    let insufficientFundsMessage = "";
    if (!hasBalance && !hasETH && contributionType !== "eth") {
      insufficientFundsMessage = <span>You have insufficient funds to pay the deposit, and you don't have enough ETH to pay any transaction fees.</span>;
    } else if (!hasBalance) {
      insufficientFundsMessage = <span>You have insufficient funds to pay the deposit.</span>;
    } else if (!hasETH) {
      insufficientFundsMessage = <span>You have insufficient ETH to pay the transaction fee.</span>;
    }

    let hasBalanceAndETH = hasBalance && hasETH;
    let hasBalanceAndETHAndAllowance = hasBalanceAndETH && hasAllowance;

    let depositBtnElem =
    <div className="moveTop10">
      {hasBalanceAndETHAndAllowance && action === "implicit_finalize" && <ButtonAction name="deploy" className="moveRight20" text="Submit deposit without approval" onClick={this.implicitDeploy}/>}
      {hasBalanceAndETHAndAllowance && action === "finalize" && <ButtonAction name="deploy" className="moveRight20" text="Submit deposit" onClick={this.deploy}/>}
      {hasBalanceAndETHAndAllowance && action === "deposit" && <ButtonAction name="deposit" className="moveRight20" text="Submit deposit" onClick={this.deposit}/>}
      {!hasBalanceAndETHAndAllowance && <ButtonAction disabled={true} name="deposit_placeholder" className="moveRight20" text={action === "implicit_finalize" ? "Submit deposit without approval" : "Submit deposit"} onClick={null}/>}
    </div>;

    let transactionLinkElement = waitingApproveAllowanceHash === "" ? "transaction" : <Link className="bluelink" target="_blank" rel="noopener noreferrer" href={shared.getTransactionLink(getTestModeFromStore(), waitingApproveAllowanceHash)}>{"transaction"}</Link>;

    return (
      <div className="contentSection depositFundsDialog" role="group" aria-label={dialogTitle}
        tabIndex={-1} ref={node => this.panel = node} onBlur={() => { this.pendingFocus = null; }}>
        <div className="contentCard">
          <DialogTitle title={dialogTitle} />
          {(youAreUser1 || youAreUser2) ? (
            <div>
              <div className="depositBalanceStatus" role={funds.status === 'error' ? 'alert' : 'status'} aria-live="polite">
                {funds.status === 'loading' && <span>Checking your wallet balance…</span>}
                {funds.status === 'error' && <span>Unable to read your wallet balance. Check your wallet connection and network, then retry.</span>}
                {ready && <span>Wallet balance: {funds.balanceDisplay} {contributionType.toUpperCase()}. Required deposit: {contributionAmount} {contributionType.toUpperCase()}. Transaction fees are additional.</span>}
                {ready && !hasBalanceAndETH && <div className="depositBalanceError">{insufficientFundsMessage}</div>}
                <button type="button" className="depositBalanceRefresh" onClick={this.refreshFunds} disabled={funds.status === 'loading'}>
                  {funds.status === 'error' ? 'Retry balance check' : 'Refresh balance'}
                </button>
              </div>
              {waitingForApproveAllowance ? (
                <div className="contentLabel">
                  <div style={{lineHeight:"18px"}}>{"Giving permission to transfer " + contributionType.toUpperCase() + " from your wallet. The "}{transactionLinkElement}{" should take about fifteen seconds."}</div>
                  <div><img style={{position:"relative", left:"-8px"}} className="loadIcon" src={loadImg} alt="Loading" /></div>
                </div>
              ) : (
                <div>
                  {
                      action === "implicit_finalize" ? 
                      <div>
                        <div>{counterPartyLinkUC} has not yet approved this payment. If you know that the payment terms are acceptable to {counterPartyLink} you can deposit {contributionType === "eth" ? contributionAmount + " " + contributionType.toUpperCase() : ""} now.</div>
                      </div> : ""
                  }
                  {contributionType === "eth" ? depositBtnElem : (
                    <div>
                      <div className="moveTop20">{"1. Give permission to the agreement contract to transfer " + contributionType.toUpperCase() + " from your wallet."}</div>
                      {ready && waitingApproveAllowanceHash !== "" && !hasAllowance && <div className="moveTop20">Your previous {transactionLinkElement} hasn't been confirmed yet. Either wait longer or try giving permission again with a higher fee.</div>}
                      <div className="moveTop10">
                        {!hasAllowance && hasETH && <ButtonAction name="allowance" className="moveRight20" text={"Give permission"} onClick={this.handleApproveAllowanceForDeposit}/>}
                        {!hasAllowance && !hasETH && <ButtonAction disabled={true} name="allowance" className="moveRight20" text={"Give permission"} onClick={null}/>}
                        {hasAllowance && <ButtonAction disabled={true} name="allowance" className="moveRight20" text={"Permission granted"} onClick={null}/>}
                      </div>
                      <div className="moveTop20">{"2. Deposit " + contributionAmount + " " + contributionType.toUpperCase() + " into the agreement contract."}</div>
                      {depositBtnElem}
                    </div>
                  )}
                </div>
              )}
            </div>
            ) : (<div>You are not a participant in this agreement.</div>)}
        </div>
        <GapCard />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    menu: state.menu,
    agreement: state.agreement,
    dialogBlockchainDeposit: state.dialogBlockchainDeposit
  }
}

const DialogBlockchainDepositContainer = connect(mapStateToProps, null)(DialogBlockchainDeposit);
export default DialogBlockchainDepositContainer;
